// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/index'
import Cookies from 'js-cookie'
import VueClipboard from 'vue-clipboard2'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import fullpath from './router/fullpath'
import store from './store'
import VueImgmode from 'vue-imgmode'
import {getUserInfo} from './req/cwApi'
import { Loading } from 'element-ui';
// import './element-variables.scss'
require('./element-variables.scss')
require('../../assets/css/reset.css')
require('../../assets/css/theme.css')

Vue.use(ElementUI)
Vue.use(VueImgmode)
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
Vue.config.productionTip = false

Vue.prototype.Cookies = Cookies

// 不管怎么说 先清空vuex中的路由表
store.commit('clearRoutes')
// 将路由表中的默认路由先连接到vuex
store.commit('concatRoutes', router.options.routes)

if (Cookies.get('PSSID')) {
    const loading =Loading.service();
    getUserInfo({pssid: Cookies.get('PSSID')}).then(res => {
        if (res.success) {
            // 相当于登陆之后的流程
            // 把用户信息存vuex中
            store.commit('updateCwUserInfo', res.data)
            
            // 内容组件模版
            let authListItems = [{
                path: '/user/',
                name: 'content',
                component: fullpath['content'],
                children: []
            }]
            // 如果有则添加路由
            const authList = res.data.authList
            // 遍历权限
            for (let i in authList) {
                // 如果权限为true，则添加到路由，中间要去除登陆和忘记密码这种公用路由
                if (authList[i] && i !== 'login' && i !== 'findpass'){
                    authListItems[0].children.push({
                        path: '/user/' + i,
                        name: i,
                        component: fullpath[i]
                    })
                }
            }
            // 连接内容路由
            store.commit('concatRoutes', authListItems)
            router.addRoutes(authListItems)
            setTimeout(() => {
              loading.close();
            }, 1500);
            // 补上404页面路由
            store.commit('concatRoutes', [{
                path: "*",
                redirect: "/user/404"
            }])
            router.addRoutes([{
                path: "*",
                redirect: "/user/404"
            }])
            // 设置PSSID
            const date = new Date()
            date.setTime(date.getTime() + parseInt(res.data.expireTime) * 1000)
            Cookies.set('PSSID', res.data.pssid, {expires: date})
            // 如果是/user这个路径，那么跳到第一个路由去
            if (window.location.pathname === '/user' || window.location.pathname === '/user/') {
                const firstComponent = store.state.fullRoutes.find((cur) => {
                    return cur.name === 'content'
                })
                router.replace(firstComponent.children[0].path)
            }
        } else {
            // 获取不到用户信息时 全部地址指向登陆，并且携带定向地址参数
            if (window.location.pathname !== '/user/login'|| window.location.pathname !== '/user/login/'|| window.location.pathname !== '/user/findpass'|| window.location.pathname !== '/user/findpass/'|| window.location.pathname !== '/user/404'|| window.location.pathname !== '/user/404/') {
                router.addRoutes([{
                    path: "*",
                    redirect: {path: "/user/login", query: {redirect: window.location.pathname}}
                }])
            } else {
                router.addRoutes([{
                    path: "*",
                    redirect: "/user/login"
                }])
            }
        }
    })

} else {
    // 这种情况是根本就没有pssid或者pssid过期
    // 获取不到用户信息时 全部地址指向登陆，并且携带参数
    if (window.location.pathname !== '/user/login'|| window.location.pathname !== '/user/login/'|| window.location.pathname !== '/user/findpass'|| window.location.pathname !== '/user/findpass/'|| window.location.pathname !== '/user/404'|| window.location.pathname !== '/user/404/') {
        router.addRoutes([{
            path: "*",
            redirect: {path: "/user/login", query: {redirect: window.location.pathname}}
        }])
    } else {
        router.addRoutes([{
            path: "*",
            redirect: "/user/login"
        }])
    }
}

/* eslint-disable no-new */
export default new Vue({
    el: '#app',
    router,
    store,
    // components: navigator.appName === 'Microsoft Internet Explorer' && parseInt(navigator.appVersion.split(';')[1].replace(/[ ]/g, '').replace('MSIE', '')) <= 9 ? { App2 } : { App },
    components: { App },
    // template: navigator.appName === 'Microsoft Internet Explorer' && parseInt(navigator.appVersion.split(';')[1].replace(/[ ]/g, '').replace('MSIE', '')) <= 9 ? '<App2/>' : '<App/>'
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/page/cw/main.js